import React from 'react';
import { useConsumption } from '../../../hooks';
import { createList } from '../../../../../common/utils/graph.utils';
import { formatDateByPeriod, getPeriodLabel } from '../../../../../common/utils/dateFormatter';
import { EChartsPresenter } from '../../../../../common/components/molecule/EChartsView';
import { EChartsData, EChartsSeries } from '../../../../../common/components/molecule/EChartsView';
import ProfessionalChartLoader from '../../../../../common/components/molecule/Chart/ChartLoaderView/ProfessionalChartLoader';
import ChartErrorView from '../../../../../common/components/molecule/Chart/ChartLoaderView/ChartErrorView';

export interface ConsumptionAndIndexChartPresenterProps {
  deviceId?: string;
}

export default function ConsumptionAndIndexChartPresenter({ deviceId }: ConsumptionAndIndexChartPresenterProps) {
  const { consunptionIndexQuery, consunptionQuery, filter } = useConsumption();
  
  const periodLabel = getPeriodLabel(filter.aggregateWindow || '1mo');
  const baseTitle = `Évolution de la Consommation ${periodLabel} d'Énergie`;
  
  if (consunptionIndexQuery.isLoading || consunptionQuery.isLoading) {
    return <ProfessionalChartLoader metricName="Index et Consommation" />;
  }

  if (consunptionIndexQuery.isError || consunptionQuery.isError) {
    const error = consunptionIndexQuery.error || consunptionQuery.error;
    return <ChartErrorView metricName="Index et Consommation" error={error as Error} />;
  }

  if (!consunptionIndexQuery.data || consunptionIndexQuery.data.length === 0 || 
      !consunptionQuery.data || consunptionQuery.data.length === 0) {
    return <ChartErrorView metricName="Index et Consommation" />;
  }

  // Traitement des données de consommation
  const dataChart = createList(filter.aggregateWindow || '1mo', filter, consunptionIndexQuery.data);
  const dataChartConsumption = createList(filter.aggregateWindow || '1mo', filter, consunptionQuery.data);
  
  // Conversion des données pour ECharts - Index de consommation (ligne)
  // null = pas de donnée (laisse un trou), 0 = valeur réelle
  const indexData: EChartsData[] = dataChart.listx
    .map((date, index) => ({
      name: formatDateByPeriod(date, filter.aggregateWindow || '1mo'),
      value: dataChart.listValue[index] ?? null,
      color: '#3b82f6'
    }));

  // Conversion des données pour ECharts - Consommation (barres)
  const consumptionData: EChartsData[] = dataChartConsumption.listx
    .map((date, index) => ({
      name: formatDateByPeriod(date, filter.aggregateWindow || '1mo'),
      value: dataChartConsumption.listValue[index] ?? null,
      color: '#10b981'
    }));

  // Création des séries combinées
  const combinedSeries: EChartsSeries[] = [
    {
      name: "Index de Consommation (kWh)",
      data: indexData,
      type: "line",
      color: "#3b82f6"
    },
    {
      name: "Consommation d'Énergie (kWh)",
      data: consumptionData,
      type: "bar",
      color: "#10b981"
    }
  ];

  return (
    <EChartsPresenter
      data={combinedSeries}
      title={baseTitle}
      type="combined"
      height={400}
      xAxisLabel="Date"
      yAxisLabel="Consommation (kWh)"
      showLegend={true}
      showTooltip={true}
    />
  );
}
